import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;


class RouteService {
  create = async (route: any) => {
    await axios.post<any>(`${API_URL}route`, route)
      .catch((e) => {
        const { message } = e.response.data;
        if (message.errorInfo) throw message.errorInfo[2];
        else throw e.message;
      });
  };

  edit = async (route: any, code: any) => {
    await axios.put<any>(`${API_URL}route/${code}`, route)
      .catch((e) => {
        const { message } = e.response.data;
        if (message.errorInfo) throw message.errorInfo[2];
        else throw e.message;
      });
  };

  get = async (code: any) => {
    const response = await axios.get<any>(`${API_URL}route/${code}`)
      .catch((e) => {
        throw e.message;
      });
    return response.data.route;
  };

  getAll = async () => {
    const response = await axios.get<any>(`${API_URL}route`)
      .catch((e) => {
        throw e.message;
      });
    return response.data.route;
  };

  search = async (keyword: any) => {
    const response = await axios.get<any>(`${API_URL}route-search/${keyword}`)
      .catch((e) => {
        throw e.message;
      });
    return response.data.route;
  };
}

export default new RouteService();
